export default "/images/278c41a222cb5a920f1564e405fb5883.avif";